import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Divider from "@mui/material/Divider";
import { useHistory } from "react-router-dom";

const StoryWithIntermission = ({ data }) => {
  const history = useHistory(); //habilitar history para redirecciones

  const { image, _id, intermission } = data;

  const onClick = (id, inter) => {
    history.push(`story-details/${id}/${inter}`);
  };

  return (
    <>
      <Grid item xs={12} md={3} sm={6} style={{ display: "flex" }}>
        <Card sx={{ maxWidth: 340, height: "100%", borderRadius: 8 }}>
          <CardMedia
            component="img"
            image={image}
            alt="storyCover"
            sx={{
              maxWidth: 340,
              height: "80%",
              cursor: "pointer",
              objectFit: "cover",
            }}
            onClick={() => onClick(_id, false)}
          />
          <Divider style={{ marginTop: 5 }} />
          <CardMedia
            component="img"
            image={intermission.image}
            alt="storyCoverIntermission"
            sx={{ maxWidth: 340, height: "20%", cursor: "pointer" }}
            onClick={() => onClick(_id, true)}
          />
        </Card>
      </Grid>
    </>
  );
};

export default StoryWithIntermission;
